"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 个股-公司关联交易明细
 */
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
require("../../src/modules/singlestocktop/web");
var base_1 = __importDefault(require("./base"));
var webconfig = require("../../config/web.js");
var name = stockInfo.name;
//币种链接
function getBiLink(code, name) {
    if (code) {
        return base_1["default"].bzMap.hasOwnProperty(code) ? "<a href=\"//quote.eastmoney.com/cnyrate/" + base_1["default"].bzMap[code] + ".html\">" + name + "</a>" : fieldtools_1["default"].strformat(name);
    }
    else {
        return fieldtools_1["default"].strformat(name);
    }
}
//详情表格
$.ajax({
    url: webconfig.getWebPath("datacenter") + "api/data/v1/get",
    type: "GET",
    dataType: "jsonp",
    data: {
        reportName: 'RPT_RELATED_TRADE',
        columns: 'TRADESECURITY_NAME_ABBR,RELATED_PARTY,DATE_TYPE_CODE,OPERATE_INCOME,NETPROFIT,TRADESECURITY_CODE,ORG_TYPE,RELATED_RELATION,IS_CONTROL,TRADE_PROFILE,PRICE_BASIS,TRADE_AMT,CURRENCY,CURRENCY_NAME,TRADE_WAY,PAY_WAY,D20_CLOSE_ADJCHRATE,NOTICE_DATE',
        filter: "(EID=\"" + id + "\")",
        source: "WEB",
        client: "WEB"
    }
}).then(function (json) {
    if (json && json.result && json.result.data.length && json.result.data.length > 0) {
        var data = json.result.data[0];
        if (!data) {
            return false;
        }
        var gsmc = !fieldtools_1["default"].isEmpty(data.TRADESECURITY_NAME_ABBR) ? data.TRADESECURITY_NAME_ABBR : data.RELATED_PARTY;
        if (gsmc) {
            name = name ? name : '';
            $('#bdName').html('-' + gsmc).attr('title', name + '-' + gsmc + '关联交易明细');
        }
        var rHtml = '<td class="title">公告年度最新财报的营业收入(元)<i class="icon icon_faq valign-middle" title="营业收入和净利润数值后的数字对应当年度不同的报告期：1-一季报、2-中报、3-三季报、4-年报"></i></td><td>-</td><td class="title">公告年度最新财报的净利润(元)</td><td>-</td>';
        if (!fieldtools_1["default"].isEmpty(data.DATE_TYPE_CODE)) {
            rHtml = '<td class="title">公告年度最新财报的营业收入(元)<i class="icon icon_faq valign-middle" title="营业收入和净利润数值后的数字对应当年度不同的报告期：1-一季报、2-中报、3-三季报、4-年报"></i></td><td>'
                + fieldtools_1["default"].fieldfmt(data.OPERATE_INCOME, { num: 2 }) + '(' + fieldtools_1["default"].strformat(data.DATE_TYPE_CODE) + ')'
                + '</td><td class="title">公告年度最新财报的净利润(元)</td><td>' + fieldtools_1["default"].fieldfmt(data.NETPROFIT, { num: 2 }) + '(' + fieldtools_1["default"].strformat(data.DATE_TYPE_CODE) + ')' + '</td>';
        }
        var gsmc1 = '';
        if (!fieldtools_1["default"].isEmpty(data.TRADESECURITY_CODE)) {
            if (data.TRADESECURITY_CODE.length == 6) {
                gsmc1 = '<a href="/stockdata/' + data.TRADESECURITY_CODE + '.html">' + data.TRADESECURITY_NAME_ABBR + '</a>';
            }
            else {
                gsmc1 = fieldtools_1["default"].strformat(data.TRADESECURITY_NAME_ABBR);
            }
        }
        else {
            gsmc1 = fieldtools_1["default"].strformat(data.RELATED_PARTY); //交易方
        }
        var html = '<tr><td rowspan="2" class="headTitle">交易方情况</td><td class="title">公司名称</td><td>' + gsmc1 + '</td>' +
            '<td class="title">公司类型</td><td>' + fieldtools_1["default"].strformat(data.ORG_TYPE) + '</td></tr><tr><td class="title">关联关系</td><td>' + fieldtools_1["default"].strformat(data.RELATED_RELATION) + '</td>' +
            '<td class="title">是否存在控制关系</td><td>' + fieldtools_1["default"].strformat(data.IS_CONTROL) + '</td></tr>' +
            '<tr><td rowspan="6" class="headTitle">交易详情</td><td class="title">交易简介</td><td colspan="3">' + fieldtools_1["default"].strformat(data.TRADE_PROFILE) + '</td></tr>' +
            '<tr><td class="title">定价依据</td><td colspan="3">' + fieldtools_1["default"].strformat(data.PRICE_BASIS) + '</td></tr>' +
            '<tr><td class="title">交易金额(元)</td><td>' + fieldtools_1["default"].fieldfmt(data.TRADE_AMT, { zoom: 4, num: 2 }) + '</td><td class="title">币种</td><td>' + getBiLink(data.CURRENCY, data.CURRENCY_NAME) + '</td></tr>' +
            '<tr><td class="title">交易方式</td><td>' + fieldtools_1["default"].strformat(data.TRADE_WAY) + '</td><td class="title">支付方式</td><td>' + fieldtools_1["default"].strformat(data.PAY_WAY) + '</td></tr>' +
            '<tr>' + rHtml + '</tr>' +
            '<tr><td class="title">公告后20日涨跌幅(%)</td><td>' + fieldtools_1["default"].fieldfmt(data.D20_CLOSE_ADJCHRATE, { num: 2, showcolor: true }) + '</td><td class="title">公告日期</td><td>' + fieldtools_1["default"].dateformat(data.NOTICE_DATE) + '</td></tr>';
        $('#gljy tbody').html(html);
    }
});
